import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { InterviewModel } from './models/interview-model';
import { OfferModel, OfferDetailsModel } from './models/offer-model';
import { InterviewSelectionModel } from './models/interview-selection-model';
import { ApplicantMessageModel } from './models/applicant-message-model';
import { ReferenceCollectionModel } from './models/reference-collection-model';
import { Answer } from '../applicant-service/service-models/Answer';
import { Message } from './models/message';

@Injectable({
  providedIn: 'root'
})
export class ApplicantFileService {
  apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  confirmInterview(jobId: number, applicantFileId: number, interviewId: number, model: InterviewSelectionModel): Observable<any> {
    return this.http.post<any>(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/interviews/${interviewId}`, model);
  }

  rejectInterview(jobId: number, applicantFileId: number, interviewId: number, message: Message): Observable<any> {
    return this.http.post<any>(
      `${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/interviews/${interviewId}/rejections`, message);
  }
  
  getInterview(jobId: number, applicantFileId: number, interviewId: number): Observable<InterviewModel> {
    return this.http.get<InterviewModel>(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/interviews/${interviewId}`);
  }

  getOffer(jobId: number, applicantFileId: number, offerId: number): Observable<OfferModel> {
    return this.http.get<OfferModel>(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/offers/${offerId}`);
  }

  respondToOffer(jobId: number, applicantFileId: number, offerId: number, model: OfferDetailsModel) {
    return this.http.put<any>(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/offers/${offerId}`,
      model);
  }

  signOffer(jobId: number, applicantFileId: number, offerId: number) {
    return this.http.put<any>(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/offers/${offerId}/signing-status`,
      { status: 'Pending', signerRole: 'Applicant' });
  }

  getApplicantMessage(jobId: number, applicantFileId: number, messageId: number): Observable<ApplicantMessageModel> {
    return this.http.get<ApplicantMessageModel>(
      `${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/messages/${messageId}`);
  }

  getReferenceCollection(jobId: number, applicantFileId: number, referenceId: number): Observable<ReferenceCollectionModel> {
    return this.http.get<ReferenceCollectionModel>(
      `${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/references/${referenceId}`);
  }

  submitReferenceCollection(
    jobId: number,
    applicantFileId: number,
    referenceFormId: number,
    referenceId: number,
    answers: Array<Answer>,
    files: Array<File>) {
    const formData = new FormData();

    formData.append('jobId', jobId.toString());
    formData.append('applicantFileId', applicantFileId.toString());
    formData.append('referenceFormId', referenceFormId.toString());
    formData.append('referenceId', referenceId.toString());
    formData.append('answers', JSON.stringify(answers));
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }

    return this.http.post<any>(
      `${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/reference-forms/`
      + `${referenceFormId}/references/${referenceId}/answers`,
      formData);
  }
}
